"use client";

import React from "react";

interface ChipProps {
  label: React.ReactNode;
  onClick?: () => void;
  active?: boolean;
  className?: string;
}

export const Chip = ({
  label,
  onClick,
  active = false,
  className = ""
}: ChipProps) => {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-2 pt-3 pb-3 rounded-full text-14-tamil-700 transition-colors whitespace-nowrap cursor-pointer gap-4 bg-ECEEF3 text-1B1B1B ${className}`}
    >
      {label}
    </button>
  );
};